export const fontSans = "'Neue Haas Unica', 'Inter', sans-serif";
export const fontSerif = "'Domaine Text', serif";

export const warmHeaderBg = '#F4F2EC';
export const headerSurfaceBg = '#FFFFFF';
export const railBg = '#577591';
export const footerBg = '#2C2C2C';
export const pageGutter = 60;
export const stickyFooterHeight = 68;

export const headerButtonStyle = {
  padding: '8px 16px',
  height: 40,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  color: '#2C2C2C',
  border: '1px solid #d8d0c4',
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 600,
  fontFamily: "'NeueHaasUnica', sans-serif",
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  cursor: 'pointer',
  boxShadow: 'none',
  outline: 'none',
  whiteSpace: 'nowrap'
};

export const primaryHeaderButtonStyle = {
  ...headerButtonStyle,
  backgroundColor: '#2C2C2C',
  color: '#fff',
  border: '1px solid transparent'
};

export const secondaryHeaderButtonStyle = {
  ...headerButtonStyle,
  backgroundColor: '#fff',
  color: '#2C2C2C',
  border: '1px solid #2C2C2C'
};

export const footerPrimaryButtonStyle = {
  height: 34,
  padding: '7px 14px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: warmHeaderBg,
  color: '#2C2C2C',
  border: '1px solid transparent',
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 600,
  fontFamily: "'NeueHaasUnica', sans-serif",
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  cursor: 'pointer',
  whiteSpace: 'nowrap'
};

export const footerSecondaryButtonStyle = {
  ...footerPrimaryButtonStyle,
  backgroundColor: 'transparent',
  color: '#fff',
  border: '1px solid rgba(255,255,255,0.55)'
};

export const textActionStyle = {
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  fontSize: 12,
  fontWeight: 400,
  color: '#2C2C2C',
  textDecoration: 'underline',
  textUnderlineOffset: 3,
  fontFamily: fontSans,
  cursor: 'pointer'
};

export function formatProductChangeCount(count) {
  const n = Number(count) || 0;
  return n === 1 ? '1 product change' : `${n} product changes`;
}

export const clientFieldFocusStyles = `
  [data-proposal-view="true"] input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="file"]):not([type="hidden"]):not([type="range"]):not([type="color"]):not(.request-changes-qty-input),
  [data-proposal-view="true"] textarea,
  [data-proposal-view="true"] select,
  .mayker-field,
  .request-add-product-modal input:not(.request-changes-qty-input),
  .request-add-product-modal textarea,
  .request-add-product-modal select,
  .accept-proposal-panel input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),
  .accept-proposal-panel textarea,
  .accept-proposal-panel select,
  .change-request-review input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),
  .change-request-review textarea,
  .change-request-review select {
    outline: none !important;
  }
  [data-proposal-view="true"] input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="file"]):not([type="hidden"]):not([type="range"]):not([type="color"]):not(.request-changes-qty-input):hover,
  [data-proposal-view="true"] textarea:hover,
  [data-proposal-view="true"] select:hover,
  .mayker-field:hover,
  .request-add-product-modal input:not(.request-changes-qty-input):hover,
  .request-add-product-modal textarea:hover,
  .request-add-product-modal select:hover,
  .accept-proposal-panel input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):hover,
  .accept-proposal-panel textarea:hover,
  .accept-proposal-panel select:hover,
  .change-request-review input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):hover,
  .change-request-review textarea:hover,
  .change-request-review select:hover {
    border-color: #c4bbb0 !important;
  }
  [data-proposal-view="true"] input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="file"]):not([type="hidden"]):not([type="range"]):not([type="color"]):not(.request-changes-qty-input):focus,
  [data-proposal-view="true"] input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="file"]):not([type="hidden"]):not([type="range"]):not([type="color"]):not(.request-changes-qty-input):focus-visible,
  [data-proposal-view="true"] textarea:focus,
  [data-proposal-view="true"] textarea:focus-visible,
  [data-proposal-view="true"] select:focus,
  [data-proposal-view="true"] select:focus-visible,
  .mayker-field:focus,
  .mayker-field:focus-visible,
  .request-add-product-modal input:not(.request-changes-qty-input):focus,
  .request-add-product-modal input:not(.request-changes-qty-input):focus-visible,
  .request-add-product-modal textarea:focus,
  .request-add-product-modal textarea:focus-visible,
  .request-add-product-modal select:focus,
  .request-add-product-modal select:focus-visible,
  .accept-proposal-panel input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):focus,
  .accept-proposal-panel input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):focus-visible,
  .accept-proposal-panel textarea:focus,
  .accept-proposal-panel textarea:focus-visible,
  .accept-proposal-panel select:focus,
  .accept-proposal-panel select:focus-visible,
  .change-request-review input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):focus,
  .change-request-review input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):focus-visible,
  .change-request-review textarea:focus,
  .change-request-review textarea:focus-visible,
  .change-request-review select:focus,
  .change-request-review select:focus-visible {
    border-width: 1px !important;
    border-style: solid !important;
    border-color: #2C2C2C !important;
    outline: none !important;
    box-shadow: none !important;
  }
  [data-proposal-view="true"] input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="file"]):not([type="hidden"]):not([type="range"]):not([type="color"]):not(.request-changes-qty-input):focus-visible,
  [data-proposal-view="true"] textarea:focus-visible,
  [data-proposal-view="true"] select:focus-visible,
  .mayker-field:focus-visible,
  .request-add-product-modal input:not(.request-changes-qty-input):focus-visible,
  .request-add-product-modal textarea:focus-visible,
  .request-add-product-modal select:focus-visible,
  .accept-proposal-panel input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):focus-visible,
  .accept-proposal-panel textarea:focus-visible,
  .accept-proposal-panel select:focus-visible,
  .change-request-review input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):focus-visible,
  .change-request-review textarea:focus-visible,
  .change-request-review select:focus-visible {
    box-shadow: 0 0 0 2px #efeae2 !important;
  }
  .request-changes-qty-input:focus,
  .request-changes-qty-input:focus-visible {
    outline: none !important;
    box-shadow: inset 0 0 0 1px #2C2C2C !important;
  }
`;
